const styles = (theme) => ({
  dialogActionsMultiple: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  dialogActionsSingle: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  dialog: {
    maxHeight: 'calc(100% - 30px)',
    maxWidth: 560,
  },
  dialogTitle: {
    textAlign: 'center',
    paddingBottom: theme.spacing.unit * 0.5,
  },
  dialogTitleLarge: {
    paddingTop: 0,
  },
  heading: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    padding: '10px 0',
    [theme.breakpoints.up('sm')]: {
      justifyContent: 'flex-start',
    },
  },
  headingInline: {
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    color: theme.palette.primary.dark,
    fontSize: '2rem',
  },
  iconLarge: {
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: theme.palette.border.lighter,
    borderRadius: '100px',
    color: theme.palette.primary.dark,
    boxSizing: 'content-box',
    marginRight: theme.spacing.unit,
    padding: 8,
    [theme.breakpoints.up('sm')]: {
      marginRight: theme.spacing.unit * 2.5,
      padding: 15,
    },
  },
  title: {
    fontSize: '1.3125rem',
    color: theme.palette.text.dark,
  },
  dialogContent: {
    '& a': {
      color: theme.palette.primary.dark,
      textDecoration: 'none',
    },
  },
  dialogText: {
    marginTop: theme.spacing.unit,
  },
  label: {
    fontWeight: 500,
  },
  supplementaryButton: {
    marginRight: theme.spacing.unit,
  },
  documentStyle: {
    textAlign: 'left',
    '& > p': {
      marginTop: theme.spacing.unit,
    },
    '& h4': {
      color: theme.palette.text.dark,
      fontFamily: 'Calibre',
      fontSize: '1.0625rem',
      fontWeight: 600,
      lineHeight: 1.4115,
      marginBottom: '1em',
      [theme.breakpoints.up('md')]: {
        fontSize: '1.125rem',
        lineHeight: 1.388,
      },
    },
    '& h4:first-child': {
      marginTop: '1em',
    },
    '& p:last-child': {
      marginBottom: 0,
    },
  },
  centre: {
    textAlign: 'center',
  },
  bottomContent: {
    margin: `-${theme.spacing.unit * 2}px ${theme.spacing.unit * 2}px ${
      theme.spacing.unit * 3
    }px`,
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing.unit * 5,
      marginRight: theme.spacing.unit * 5,
    },
  },
});

export default styles;
